<template>
  <v-container>
    <v-row class="align-center justify-end">
      <v-btn
          color="primary"
          dark
          class="mb-2 text-body-2"
          @click="goToCreateSlider"
      >{{ addSlide }}
      </v-btn>
    </v-row>
    <v-data-table
        v-if="feedbackConf && feedbackConf.length > 0"
        :headers="headers"
        :items="feedbackConf"
        class="elevation-1"
        sort-by="id"
        sort-desc
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.image_src="{ item }">
        <v-img
            :src="item.image_src"
            :alt="item.title"
            :title="item.title"
            width="200"
            height="200"
        ></v-img>
      </template>
    </v-data-table>
    <create-feedback-user-dialog
        :feedbackId="currentSliderId"
        :dialog="showCreateSliderDialog"
        @onClickOutside="showCreateSliderDialog = false"
        @closePopup="closePopup"
    ></create-feedback-user-dialog>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import {
  GET_HOME_PAGE_CONF,
  GET_FEEDBACK_CONF,
  SAVE_CONF,
  DELETE_FEEDBACK
} from "@/store/setting.module";
import CreateFeedbackUserDialog from "@/views/dialogs/create-feedback-user-dialog.vue";
import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";

export default {
  data() {
    return {
      headers: [
        {text: "STT", value: "id"},
        {text: "Tên", value: "name"},
        {text: "Ảnh", value: "image_src", sortable: false},
        {text: "vị trí", value: "position", sortable: false},
        {text: "phản hồi", value: "feedback", sortable: false},
        {text: "Sửa/Xóa", value: "actions", sortable: false}
      ],
      editedIndex: -1,
      cardImg: "",
      editedItem: {
        word: "",
        example: "",
        translate: "",
        note: "",
        cardImg: ""
      },
      defaultItem: {
        word: "",
        example: "",
        transalte: "",
        note: "",
        images: {}
      },
      image: {},
      currentSliderId: 0,
      showCreateSliderDialog: false,
      addSlide: "Thêm slider",
    };
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Cấu hình Trang chủ", titledad: 'Cấu hình'}]);
  },
  computed: {
    ...mapGetters({
      feedbackConf: "feedbackConf"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New card" : "Edit card";
    },
    submitTypeName() {
      return this.editedIndex === -1 ? "Save" : "Update";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  components: {
    CreateFeedbackUserDialog
  },
  methods: {
    goToCreateSlider() {
      this.currentSliderId = this.feedbackConf ? this.feedbackConf.length : 0;
      this.showCreateSliderDialog = true;
    },
    editItem(item) {
      this.$store.commit(GET_FEEDBACK_CONF, item.id);
      this.showCreateSliderDialog = true;
    },
    async deleteItem(item) {
      this.$store.commit(DELETE_FEEDBACK, item);
      let data = {
        key: 'feedback',
        value: this.feedbackConf
      }
      confirm("Are you sure you want to delete this item?") &&
      await this.$store.dispatch(SAVE_CONF, data)
    },

    close() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    onChangeFileUpload() {
    },
    clearImage() {
    },
    closePopup() {
      this.reloadConfig();
      this.showCreateSliderDialog = false;
    },
    reloadConfig() {
      this.$store.dispatch(GET_HOME_PAGE_CONF);
    }
  }
};
</script>

<style lang="scss"></style>
